import React, { createContext, useCallback, useContext, useState } from 'react';
import type { FC, ReactNode } from 'react';

import DevOverrides from 'src/utils/DevOverrides';

interface AgentDebugLogsContextValue {
  showDebugLogs: boolean;
  toggleDebugLogs: () => void;
}

const AgentDebugLogsContext = createContext<AgentDebugLogsContextValue>({
  showDebugLogs: false,
  toggleDebugLogs: () => {},
});

export const AgentDebugLogsProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [showDebugLogs, setShowDebugLogs] = useState(() => DevOverrides.getShowAgentDebugLogs());

  const toggleDebugLogs = useCallback(() => {
    setShowDebugLogs((prev) => {
      const next = !prev;
      DevOverrides.setShowAgentDebugLogs(next);
      return next;
    });
  }, []);

  return (
    <AgentDebugLogsContext.Provider value={{ showDebugLogs, toggleDebugLogs }}>
      {children}
    </AgentDebugLogsContext.Provider>
  );
};

export const useAgentDebugLogs = () => useContext(AgentDebugLogsContext);
